import {Component, Input, OnInit} from '@angular/core';
import {DossierIntervention} from 'app/models/dossier_intervention.model';
import {NomPiece} from 'app/models/nomPiece.model';
import {PieceEquipement} from 'app/models/pieceEquipement.model';
import {EquipementService} from 'app/services/equipement.service';
import {
    ModalDossierEquipement
} from './modal-dossier-equipement/modal-dossier-equipement.component';
import {MatDialog, MatDialogRef} from '@angular/material/dialog';
import {ModalConfirm} from '../../../shared/modal-confirm/modal-confirm.component';
import {UserService} from '../../../core/user/user.service';
import {DossierInterventionService} from '../../../services/dossier_intervention.service';

@Component({
    selector: 'app-dossier-equipement',
    templateUrl: './dossier-equipement.component.html',
    styleUrls: ['./dossier-equipement.component.scss']
})
export class DossierEquipementComponent implements OnInit {
    @Input() currentDossierIntervention: DossierIntervention;
    piecesEquipements: PieceEquipement[] = [];
    nomsPieces: NomPiece[] = [];

    constructor(
        private equipementService: EquipementService,
        private userService: UserService,
        private dossierService: DossierInterventionService,
        private dialog: MatDialog,
    ) {
    }

    get isAdmin(): boolean {
        return this.userService.getCurrentUser().role_id === 1;
    }

    ngOnInit(): void {
        this.getPiecesEquipementsLaisse();
    }

    getPiecesEquipementsLaisse(): void {
        this.equipementService.getPieceEquipementsLaissesParIdDossierIntervention(this.currentDossierIntervention.id).subscribe((result) => {
            this.piecesEquipements = result.piecesEquipements;
            this.nomsPieces = result.nomsPieces;
        });
    }

    getNomPiece(pieceEquipement: PieceEquipement): string {
        if (pieceEquipement.piece != null && pieceEquipement.piece.nom_piece_id != null) {
            return this.nomsPieces.find(nomPiece => nomPiece.id == pieceEquipement.piece.nom_piece_id).nom;
        } else {
            return '';
        }
    }

    /**
     * Track by function for ngFor loops
     *
     * @param index
     * @param item
     */
    trackByFn(index: number, item: any): any {
        return item.id || index;
    }

    store(): void {
        const dialogRef = this.openPieceModal();
    }

    update(pieceEquipement: PieceEquipement): void {
        const dialogRef = this.openPieceModal();

        dialogRef.componentInstance.pieceEquipement = pieceEquipement;
    }

    destroy(pieceEquipement: PieceEquipement): void {
        const dialogRef = this.dialog.open(ModalConfirm, {
            width: '50%',
        });
        dialogRef.componentInstance.confirmationMessage = 'Voulez-vous supprimer cet équipement de ce dossier?';
        dialogRef.afterClosed().subscribe((result) => {
            if(result === true) {
                this.dossierService.destroyPieceEquipementForDossierIntervention(this.currentDossierIntervention.id, pieceEquipement).subscribe(()=>{
                    this.getPiecesEquipementsLaisse();
                });
            }
        });
    }

    openPieceModal(): MatDialogRef<ModalDossierEquipement> {
        const dialogRef = this.dialog.open(ModalDossierEquipement, {
            width: '75%',
        });

        dialogRef.componentInstance.idDossierIntervention = this.currentDossierIntervention.id;

        dialogRef.afterClosed().subscribe((result) => {
            this.getPiecesEquipementsLaisse();
        });

        return dialogRef;
    }
}
